import { renewTokens } from '../../store'

export class CustomReconnectPolicy {
    nextRetryDelayInMilliseconds(retryContext: signalR.RetryContext) {
        const error = retryContext.retryReason;

        if (error?.message?.includes("401") || error?.message?.includes("Unauthorized")) {
            console.log("401 detected, triggering token refresh");
            renewTokens()
                .then(() => console.info('Tokens updated'))
                .catch(console.error);
        }
        return 5000 // Retry every 5 seconds until reconnected
    }
}